import { render, staticRenderFns } from "./InviteUsers.vue?vue&type=template&id=6ec3e2b0"
import script from "./InviteUsers.vue?vue&type=script&lang=js"
export * from "./InviteUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports